import {PaymentStatusType} from "@app/shared/enums/payment-status-type.enum";
import {PaymentType} from "@app/shared/enums/payment-type.enum";

export class VoucherRegisterSummary {
  id: number;
  version: number;
  invoicePaymentId: number;
  invoicePaymentDate: Date;
  paymentProcessedDate: Date;
  businessName: string;
  vendorId: number;
  invoiceId: number;
  invoiceNumber: number;
  customerInvNumber: string;
  paymentType: PaymentType;
  paymentStatus: PaymentStatusType;
  vrPaymentStatus: PaymentStatusType;
  amountPaid: number;
  checkNumber: string;
  referenceNumber: string;
  processed: boolean;
  empId: number;
  employeeName: string;
  expenseId: number;
  expenseReportNumber: number;
  expenseApprovalDate: Date;
  expensePaymentDate: Date;
  }
